module.exports = __webpack_public_path__ + "static/media/restaurant.34301ae7.png";